<template>
<!--  <transition name="layout">-->
    <template v-if="layoutName">
      <default-layout />
    </template>
    <template v-else>
      <router-view :key="$route.fullPath"/>
    </template>
<!--  </transition>-->
</template>

<script>
import { getToken } from "./api/utils";
import { getAuthToken, removeAuthData, setAuthToken, setLocale, getSiteData } from "@/libs/auth-helper";
import DefaultLayout from "./layouts/DefaultLayout.vue";
// import PopupLayout from './layouts/PopupLayout.vue'
// import LoginLayout from './layouts/LoginLayout.vue'
import { mapActions, mapMutations } from "vuex";
import Stomp from "webstomp-client";
import SockJs from "sockjs-client";
import { getCode } from "@/api/utils";
import {decrypt} from "@/libs/crypto";

// import { setLangs } from '@/utils/common'

export default {
  name: "App",
  components: {
    "default-layout": DefaultLayout
    // 'popup-layout': PopupLayout,
    // 'login-layout': LoginLayout
  },
  data() {
    return {
      hasError: false,
      lang: {},
      stompClient: null,
      isConnectSocket: false,
      refreshingToken: false
    };
  },
  async mounted () {
    window.CMS_TOKEN_CHECK = setInterval(async () => {
      await this.getCheckToken()
    }, 1000 * 4)
  },
  beforeUnmount () {
    clearInterval(window.CMS_TOKEN_CHECK)
  },
  computed: {
    layoutName() {
      // console.log(this.$route)
      // console.log(this.$route.matched.length)
      if (!this.$route.matched.length) {
        return null;
      }

      const route = this.$route;
      // console.log(route)
      const menuMember = route.meta.menuMember;
      let useLayout = true;
      if (!menuMember) {
        useLayout = false;
      }

      return useLayout;
    }
  },
  watch: {
    $route: {
      async handler (current) {
        if (current.name !== null) {
          const authToken = getAuthToken()
          if (!authToken) {
            this.signOut()
          } else {
            this.socketConnect()
            await this.getCheckToken()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    async getCheckToken () {
      if (this.refreshingToken) return
      const cookie = getAuthToken()
      if (!cookie) {
        this.signOut()
        return
      }
      let expires
      try {
        const base64Payload = cookie.split('.')[1]
        const payload = Buffer.from(base64Payload, 'base64')
        const result = JSON.parse(payload.toString())
        if (typeof result.exp !== 'number' || !Number.isFinite(result.exp)) throw new Error('Invalid expiry')
        expires = result.exp * 1000
      } catch (error) {
        this.signOut()
        return
      }
      if (expires - Date.now() > 5 * 60 * 1000) return

      this.refreshingToken = true
      try {
        const res = await getToken()
        // Ignore an old request if the user signed out or logged in again.
        if (getAuthToken() !== cookie) return
        if (res.resultCode !== '0' || !res.data || typeof res.data.token !== 'string' || !res.data.token.trim()) {
          this.signOut()
        } else {
          setAuthToken(res.data)
          this.socketDisconnect()
          this.socketConnect()
        }
      } catch (error) {
        // A network failure must not discard a still-valid session.
        if (getAuthToken() === cookie && expires <= Date.now()) this.signOut()
      } finally {
        this.refreshingToken = false
      }
    },
    socketDisconnect () {
      if (this.stompClient) {
        if (this.stompClient.client) {
        }
      }
      this.stompClient = null
    },
    socketConnect (type = 'super', chatId = '1') {
      const token = getAuthToken()
      if (!token) {
        if (this.stompClient) {
          this.socketDisconnect()
        }
      }
      if (token && !this.stompClient) {
        this.stompClient = {
          client: null,
          token,
          type,
          chatId
        }
        const serverURL = process.env.VUE_APP_WEB_SOCKET_URL
        const socket = new SockJs(serverURL)
        this.stompClient.client = Stomp.over(socket, { debug: false })
        this.stompClient.client.connect(
          {},
          frame => {
            // 소켓 연결 성공
            // 서버의 메시지 전송 endpoint를 구독합니다.
            // 이런형태를 pub sub 구조라고 합니다.
            const currentToken = getAuthToken()
            setTimeout(() => {
              this.stompClient.client.subscribe('/topic/' + type + '/' + currentToken, res => {
                this.getCheckToken()
                const jsonData = decrypt(res.body)
                const content = jsonData.content || null
                if (content) {
                  const msg = JSON.parse(jsonData.content)
                  this.$store.dispatch("inputHeadCashInfo", msg);
                }
              })
            }, 500)
          },
          error => {
            // 소켓 연결 실패
            console.log('111')
            console.error(error)
            this.socketDisconnect()
            this.socketConnect()
          }
        )
      }
    },
    connect(token) {
      const serverUrl = "http://139.162.68.54/websocket";
      let socket = new SockJs(serverUrl);
      this.stompClient.client = Stomp.over(socket);
      this.stompClient.client.debug = () => {}
      // this.socket.stompClient.debug = null;
      // console.log(`Connect : ${serverUrl}`);
      this.stompClient.client.connect(
        {},
        frame => {
          // this.connected = true;
          // console.log("Connected : " + frame);
          this.isConnectSocket = true;

          this.stompClient.client.subscribe("/topic/super/" + token, res => {
            console.log("Sock Response");
            let result = decrypt(res.body);
            if (result.content) {
              const msg = JSON.parse(result.content);
              //socket todo
              this.$store.dispatch("inputHeadCashInfo", msg);
            }
          });
        },
        err => {
          console.log(`Connected Failed : ${err}`);
          this.isConnectSocket = false;
        }
      );
    },
    async disconnect() {
      if (this.stompClient.client) {
        await this.stompClient.client.disconnect();
        this.stompClient.client = null;
        this.stompClient.token = null;
      }
      this.isConnectSocket = false;
    },
    ...mapMutations(["setErrorData", "clearAllSiteData"]),
    signOut() {
      this.socketDisconnect()
      this.clearAllSiteData();
      removeAuthData();
      if (this.$route.name !== "login") this.$router.replace({ name: "login" });
    }
  },
  created() {
    const token = getAuthToken()
    this.socketConnect()
  },
  beforeRouteEnter(to, from, next) {
    next();
  }
};
</script>

<style>
/* .loginBody {
  background: #eee;
  height:100vh;
  min-width: 0;
} */
</style>
